import type { ToolActivity } from "../tool-activity";
import { toolInput } from "../tool-input";
import type { ToolActivityState } from "../tool-activity-state";
import { captureLabel } from "./capture-label";
import { captureTarget } from "./capture-target";
import { CAPTURE_LABEL_MAX } from "./capture-label-constants";

export function describeRecordVideo(
  record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  const target = captureTarget(toolInput.str(record.url));
  return captureLabel(
    {
      // record_video has no option variant: a strip thumb is a still image.
      optionFailed: "Failed to record a video",
      optionRunning: "Recording a video",
      optionDone: "Recorded a video",
      failed: (subject) =>
        subject
          ? `Failed to record a video of ${subject}`
          : "Failed to record a video",
      running: (subject) =>
        subject ? `Recording a video of ${subject}` : "Recording a video",
      done: (subject) =>
        subject ? `Recorded a video of ${subject}` : "Recorded a video",
    },
    state,
    {
      isOption: false,
      subject: target ? toolInput.truncate(target, CAPTURE_LABEL_MAX) : null,
    },
  );
}
